import { Component, OnInit } from '@angular/core';
import { GenerateWarrantyService } from '../../../core/services/generate-warranty.service';
import { IGetOrdersInquiryBody, IGetGenerateWarrantyBody, IGetRelatedServiceOrderBody, IOrderInquiry, IGenerateWarranty, IGenerateWarrantyLabel } from '../../../core/models';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../core/common';
import { StatePersistingService } from '../../../core/services/state-persisting.service';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { CommonService } from '../../../core/services/common.service';
import { UserService } from '../../../core/services/user.service';
import { formatDate } from '@angular/common';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { environment } from '../../../../environments/environment';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-generate-warranty',
  templateUrl: './generate-warranty.component.html',
  styleUrls: ['./generate-warranty.component.scss']
})
export class GenerateWarrantyComponent implements OnInit {
  public gridData: IGenerateWarranty[] = [];

  popDialogue: boolean = false;
  //public serviceDetails:IGenerateWarranty[]=[];
  public serviceDetails: string;
  toDate: Date = new Date();
  fromDate: Date = new Date(this.toDate.getFullYear() - 1, this.toDate.getMonth(), this.toDate.getDay());//have kept to get data
  searchTextGenerateWarranty: string = '';
  //#region label declaration
  protected generateWarranty = {
    serviceOrderLbl: 'Service Order #',
    orderTypeLbl: 'Order Type',
    orderDateLbl: 'Order Date',
    scheduleDateLbl: 'Schedule Date',
    jobNameLbl: 'Job Name',
    jobNumberLbl: 'Job Number',
    poLbl: 'PO #',
    shipFromLbl: 'Ship From',
    finishWarrantyLbl: 'Finished Warranty',
    materialWorkmanshipLbl: 'Material/Workmanship',
    downloadWarrantyLbl: 'Download Warranty',
    relatedServiceLbl: 'Related Service Orders',
    exportToExcelLbl: 'Export To Excel',
    exportToPdfLbl: 'Export To PDF',
    generateWarantyLbl: 'Generate Warranty',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',
  };
  protected warrantyLblText: IGenerateWarrantyLabel = {
    finishWarrantyLbl: '',
    jobNameLbl: '',
    jobNumberLbl: '',
    kdRefLbl: '',
    pageTitle: '',
    materialWorkmanshipLbl: '',
    orderDateLbl: '',
    purchaseOrderLbl: '',
    relatedSOsLbl: '',
    serviceOrderLbl: '',
    shipFromLbl: '',
    orderTypeLbl: '',
    poLbl: '',
    scheduleDateLbl: '',
    downloadWarrantyLbl: '',
    relatedServiceLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
  };

  //#endregion
  //#region Language translate
  LoadLanguageTranslationData() {
    const controlNameList = [{ controlName: "finishWarrantyLbl" },
    { controlName: "jobNameLbl" },
    { controlName: "jobNumberLbl" },
    { controlName: "kdRefLbl" },
    { controlName: "materialWorkmanshipLbl" },
    { controlName: "orderDateLbl" },
    { controlName: "pageTitle" },
    { controlName: "purchaseOrderLbl" },
    { controlName: "relatedSOsLbl" },
    { controlName: "serviceOrderLbl" },
    { controlName: "shipFromLbl" },
    { controlName: "orderTypeLbl" },
    { controlName: "poLbl" },
    { controlName: "downloadWarrantyLbl" },
    { controlName: "scheduleDateLbl" },
    { controlName: "relatedServiceLbl" },
    { controlName: "exportToExcelLbl" },
    { controlName: "exportToPdfLbl" },
    ];

    const componentName = "generateWarranty";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    this.warrantyLblText = response[response.length - 1];
    console.log(response);
    this.initializeGridHeader();
  }

  //#endregion
  //#region pagination, sorting,filtering for order grid

  public generateWarrantyGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'serviceOrderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: [{
        field: "orderDateAsDate", operator: "gte", value: this.fromDate
      }, {
        field: "orderDateAsDate", operator: "lte", value: this.toDate
      }]
    },
  };

  public gridSettings: GridSettings = {
    state: this.generateWarrantyGridstate,
    gridData: process(this.gridData, this.generateWarrantyGridstate),
    columnsConfig: [{
      field: 'serviceOrderNumber',
      title: this.warrantyLblText.serviceOrderLbl ? this.warrantyLblText.serviceOrderLbl : this.generateWarranty.serviceOrderLbl,
      filterable: true,
      _width: 240

    },
    //{
    //field: 'orderType',
    //title: this.generateWarranty.orderType,
    //filterable: true
    //},
    {
      field: 'orderDateAsDate',
      title: this.warrantyLblText.orderDateLbl ? this.warrantyLblText.orderDateLbl : this.generateWarranty.orderDateLbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 240,
      filterable: true
    }, {
      field: 'scheduleDateAsDate',
      title: this.warrantyLblText.scheduleDateLbl ? this.warrantyLblText.scheduleDateLbl : this.generateWarranty.scheduleDateLbl,
      filter: 'date',
      format: '{0:d}',
      _width: 240,
      filterable: true
    }, {
      field: 'jobName',
      title: this.warrantyLblText.jobNameLbl ? this.warrantyLblText.jobNameLbl : this.generateWarranty.jobNameLbl,
      filterable: true
    }, {
      field: 'jobNumber',
      title: this.warrantyLblText.jobNumberLbl ? this.warrantyLblText.jobNumberLbl : this.generateWarranty.jobNumberLbl,
      filterable: true
    }, {
      field: 'poNumber',
      title: this.warrantyLblText.poLbl ? this.warrantyLblText.poLbl : this.generateWarranty.poLbl,
      filterable: true
    },
    {
      field: 'shipFrom',
      title: this.warrantyLblText.shipFromLbl ? this.warrantyLblText.shipFromLbl : this.generateWarranty.shipFromLbl,
      filterable: true
    },
    //{
    //  field: 'finishedWarranty',
    //  title: this.warrantyLblText.finishWarrantyLbl ? this.warrantyLblText.finishWarrantyLbl : this.generateWarranty.finishWarrantyLbl,
    //  filterable: true
    //},
    //{
    //  field: 'workmanship',
    //  title: this.warrantyLblText.materialWorkmanshipLbl ? this.warrantyLblText.materialWorkmanshipLbl : this.generateWarranty.materialWorkmanshipLbl,
    //  filterable: true
    //},
    {
      field: 'downloadWarranty',
      title: 'Download Warranty',
      filterable: false
    }
    ]
  };

  loadingPDF: boolean;
  loadingExcel: boolean;

  constructor(private generateWarrantyService: GenerateWarrantyService, private persistingService: StatePersistingService,
    private commonService: CommonService, private userService: UserService, private languageTranslationService: LanguageTranslationService) {
    const gridSettings: GridSettings = this.persistingService.get(this.generateWarrantyService.readUserObject.userName + 'generateWarrantyGrid');

    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
      //if (this.gridSettings.state.filter.filters[0]['field'] == "orderDateAsDate") {
      //  this.gridSettings.state.filter.filters[0]['value'] = new Date(this.gridSettings.state.filter.filters[0]['value']);
      //  this.gridSettings.state.filter.filters[1]['value'] = new Date(this.gridSettings.state.filter.filters[1]['value']);
      //}
    }
  }
  generateWarrantyGridData: GridDataResult;

  ngOnInit() {
    this.loadGenerateWarrantyGrid(this.fromDate, this.toDate);
    this.LoadLanguageTranslationData();
  }

  //#region Grid data binding
  generateWarrantyLoading: boolean;
  private loadGenerateWarrantyGrid(fromDate: Date, toDate: Date): void {
    //call service here and fetch the grid data
    this.generateWarrantyLoading = true;
    const body: IGetGenerateWarrantyBody = {
      customerNumber: '',
      fromDate: fromDate,
      toDate: toDate,
      isFrench: false,
    }
    this.generateWarrantyService.getOrders(body).subscribe((response: Array<IGenerateWarranty>) => {

      this.gridData = response;
      this.loadGenerateWarrantyGridData();
      this.generateWarrantyLoading = false;
      console.log(this.gridData);

    })
  }
  //#endregion




  defaultSort = [{
    field: 'serviceOrderNumber',
    dir: 'desc'
  }];

  private loadGenerateWarrantyGridData(): void {
    if (this.gridSettings.state) {
      this.generateWarrantyGridData = process(this.gridData, this.gridSettings.state);
    }
    else {
      this.generateWarrantyGridData = process(this.gridData, this.generateWarrantyGridstate);
    }
    this.gridSettings.gridData = this.generateWarrantyGridData;
  }

  protected generateWarrantyGridSortChange(sort): void {
    this.generateWarrantyGridstate.sort = sort;
    this.loadGenerateWarrantyGridData();
  }

  protected generateWarrantyGridPageChange({ skip, take }: PageChangeEvent): void {
    this.generateWarrantyGridstate.skip = skip;
    this.generateWarrantyGridstate.take;
    this.loadGenerateWarrantyGridData();
  }
  //when older date from fromDate and later date from toDate is selected
  //api call would be made or else filter would happen clientside
  public generateWarrantyDataStateChange(state: DataStateChangeEvent): void {
    console.log(state);
    //debugger;
    this.generateWarrantyGridstate = state;
    this.gridSettings.state = this.generateWarrantyGridstate;
    var newFromDate = new Date("01/01/2000");
    var newToDate = new Date("12/31/2099");
    const filters: any[] = state.filter.filters || [];
    var orderDatefilter = filters.filter(f => f.field == "orderDateAsDate")
    if (orderDatefilter) {
      this.searchTextGenerateWarranty = '';
      orderDatefilter.forEach(filter => {
        newFromDate = (filter.operator == "gte") ? new Date(filter.value) : newFromDate;
        newToDate = (filter.operator == "lte") ? new Date(filter.value) : newToDate;
      });
      if ((newFromDate && newFromDate < this.fromDate) || (newToDate && newToDate > this.toDate)) {
        this.fromDate = newFromDate;
        this.toDate = newToDate;
        this.loadGenerateWarrantyGrid(newFromDate, newToDate);
      }
      else {
        this.loadGenerateWarrantyGridData();
      }
    }
    else {
      this.loadGenerateWarrantyGridData();
    }

    this.saveGrid();
  }

  //#endregion

  //storing the clicked row data in service
  //orderDetail(val: string) {
  //const rowData = this.generateWarrantyGridData.data.find(r => r.orderNumber === val);
  //this.generateWarrantyService.setOrderInquiryData(rowData);
  //}

  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }

  private saveGrid(): void {
    this.gridSettings.state.skip = 0;
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };
    this.persistingService.set(this.generateWarrantyService.readUserObject.userName + 'generateWarrantyGrid', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;

    let a = [];
    //may need some additional sanity checks here
    let minDate = state.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'gte');
    let maxDate = state.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'lte');

    if (!minDate || !maxDate) {
      minDate = this.generateWarrantyGridstate.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'gte');
      maxDate = this.generateWarrantyGridstate.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'lte');
    }

    a.push(minDate);
    a.push(maxDate);
    gridSettings.state.filter.filters = a;

    const filters: any[] = state.filter.filters || [];
    filters.forEach(filter => {
      if (filter.field === 'orderDateAsDate' && filter.value) {
        filter.value = new Date(filter.value);
      }
      else {
        const index: number = filters.indexOf(filter);
        if (index !== -1) {
          filters.splice(index, 1); //dont want to save other filters
        }
      }

    });
    var orderDatefilter = filters.filter(f => f.field == "orderDateAsDate")
    if (orderDatefilter && orderDatefilter.length > 0) {
      orderDatefilter.forEach(filter => {
        this.fromDate = (filter.operator == "gte") ? new Date(filter.value) : new Date("01/01/2000");
        this.toDate = (filter.operator == "lte") ? new Date(filter.value) : new Date("12/31/2099");
      });
    }
    else {
      state.filter = this.generateWarrantyGridstate.filter;
    }
    //---------------------------

    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.gridData, state)
    };
  }



  openDialogue(dataItem) {
    const orderNo = dataItem.serviceOrderNumber;
    dataItem.serviceOrderNumberProgress = true;
    const body: IGetRelatedServiceOrderBody = {
      customerNumber: this.generateWarrantyService.readUserObject.customerNumber,//'120044',
      orderNumber: orderNo
    }
    this.generateWarrantyService.getDetailsOfServiceOrder(body).subscribe((response: Array<IGenerateWarranty>) => {
      this.popDialogue = true;
      dataItem.serviceOrderNumberProgress = false;
      //debugger;
      // console.log(response);
      //var abc = Array.prototype.map.call(response, function (item) { return item.orderNumber; }).join(",");
      this.serviceDetails = Array.prototype.map.call(response, function (item) { return item.orderNumber; }).join(", ");
    })
  }

  closeDialogue() {
    this.popDialogue = false;
  }

  downloadWarranty(body) {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    body.downloadProgress = true;
    this.generateWarrantyService.downloadWarranty(body).subscribe((response) => {
      console.log(response.urlPath);
      if (response) {
        //Code to open pdf in new tab------------Start
        //var byteCharacters = atob(response.urlPath);
        //var byteNumbers = new Array(byteCharacters.length);
        //for (var i = 0; i < byteCharacters.length; i++) {
        //  byteNumbers[i] = byteCharacters.charCodeAt(i);
        //}
        //var byteArray = new Uint8Array(byteNumbers);
        //var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        //var fileURL = URL.createObjectURL(file);
        //window.open(fileURL);
        //fs.saveAs(`${environment.apiUrl}${response.urlPath}`, 'Warranty.pdf', {
        //  type: "application/pdf"
        //});
        //Code to open pdf in new tab------------End
        //Code to download pdf automatically----------- Start                        

        const linkSource = 'data:application/pdf;base64,' + response.urlPath;
        const downloadLink = document.createElement("a");
        let ms = Date.now();
        const fileName = "Warranty_" + ms + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        //Code to download pdf automatically----------- End 
      }
      body.downloadProgress = false;
    });
  }

  async generatePDF() {
    this.loadingPDF = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Warranty', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: "Customer Number:  " + this.generateWarrantyService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Customer Name: " + this.generateWarrantyService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Warranty List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: [57, 63, 63, 80, 60, 57, 80],

            body: [
              [
                this.warrantyLblText.serviceOrderLbl ? this.warrantyLblText.serviceOrderLbl : this.generateWarranty.serviceOrderLbl,
                this.warrantyLblText.orderDateLbl ? this.warrantyLblText.orderDateLbl : this.generateWarranty.orderDateLbl,
                this.warrantyLblText.scheduleDateLbl ? this.warrantyLblText.scheduleDateLbl : this.generateWarranty.scheduleDateLbl,
                this.warrantyLblText.jobNameLbl ? this.warrantyLblText.jobNameLbl : this.generateWarranty.jobNameLbl,
                this.warrantyLblText.jobNumberLbl ? this.warrantyLblText.jobNumberLbl : this.generateWarranty.jobNumberLbl,
                this.warrantyLblText.poLbl ? this.warrantyLblText.poLbl : this.generateWarranty.poLbl,
                this.warrantyLblText.shipFromLbl ? this.warrantyLblText.shipFromLbl : this.generateWarranty.shipFromLbl,
                //this.warrantyLblText.materialWorkmanshipLbl ? this.warrantyLblText.materialWorkmanshipLbl : this.generateWarranty.materialWorkmanshipLbl, 
                //this.warrantyLblText.finishWarrantyLbl ? this.warrantyLblText.finishWarrantyLbl : this.generateWarranty.finishWarrantyLbl
              ],
              ...filterData.data.map(p =>
              ([
                p.serviceOrderNumber ? p.serviceOrderNumber : '',
                p.orderDateUIString ? p.orderDateUIString : '',
                p.scheduleDateUIString ? p.scheduleDateUIString : '',
                p.jobName ? p.jobName : '',
                p.jobNumber ? p.jobNumber : '',
                p.poNumber ? p.poNumber : '',
                p.shipFrom ? p.shipFrom : '',
                //p.workmanship,
                //p.finishedWarranty
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('Warranty.pdf');
    this.loadingPDF = false;
  }

  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Warranty');
    const header = [this.warrantyLblText.serviceOrderLbl ? this.warrantyLblText.serviceOrderLbl : this.generateWarranty.serviceOrderLbl,
    this.warrantyLblText.orderDateLbl ? this.warrantyLblText.orderDateLbl : this.generateWarranty.orderDateLbl,
    this.warrantyLblText.scheduleDateLbl ? this.warrantyLblText.scheduleDateLbl : this.generateWarranty.scheduleDateLbl,
    this.warrantyLblText.jobNameLbl ? this.warrantyLblText.jobNameLbl : this.generateWarranty.jobNameLbl,
    this.warrantyLblText.jobNumberLbl ? this.warrantyLblText.jobNumberLbl : this.generateWarranty.jobNumberLbl,
    this.warrantyLblText.poLbl ? this.warrantyLblText.poLbl : this.generateWarranty.poLbl,
    this.warrantyLblText.shipFromLbl ? this.warrantyLblText.shipFromLbl : this.generateWarranty.shipFromLbl,
    ];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow(['Customer Number: '+ this.generateWarrantyService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow(['Customer Name: '+ this.generateWarrantyService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['Warranty']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
    ([
      p.serviceOrderNumber ? p.serviceOrderNumber : '',
      p.orderDateUIString ? p.orderDateUIString : '',
      p.scheduleDateUIString ? p.scheduleDateUIString : '',
      p.jobName ? p.jobName : '',
      p.jobNumber ? p.jobNumber : '',
      p.poNumber ? p.poNumber : '',
      p.shipFrom ? p.shipFrom : ''
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Warranty.xlsx');
    })
    this.loadingExcel = false;

  }

  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {

      if (el.field == 'serviceOrderNumber') {
        el.title = this.warrantyLblText.serviceOrderLbl ? this.warrantyLblText.serviceOrderLbl : this.generateWarranty.serviceOrderLbl;
      }
      if (el.field == 'orderDateAsDate') {
        el.title = this.warrantyLblText.orderDateLbl ? this.warrantyLblText.orderDateLbl : this.generateWarranty.orderDateLbl;

      }
      if (el.field == 'scheduleDateAsDate') {
        el.title = this.warrantyLblText.scheduleDateLbl ? this.warrantyLblText.scheduleDateLbl : this.generateWarranty.scheduleDateLbl;

      }
      if (el.field == 'jobName') {
        el.title = this.warrantyLblText.jobNameLbl ? this.warrantyLblText.jobNameLbl : this.generateWarranty.jobNameLbl;
      }
      if (el.field == 'jobNumber') {
        el.title = this.warrantyLblText.jobNumberLbl ? this.warrantyLblText.jobNumberLbl : this.generateWarranty.jobNumberLbl;
      }
      if (el.field == 'poNumber') {
        el.title = this.warrantyLblText.poLbl ? this.warrantyLblText.poLbl : this.generateWarranty.poLbl;
      } if (el.field == 'shipFrom') {
        el.title = this.warrantyLblText.shipFromLbl ? this.warrantyLblText.shipFromLbl : this.generateWarranty.shipFromLbl;
      }
      if (el.field == 'downloadWarranty') {
        el.title = 'Download Warranty';
      }


    });
  }

  public onFilterGenerateWarranty(inputValue: string): void {
    var primaryFilter = this.gridSettings.state.filter;
    var primaryFilteredData = process(this.gridData, {
      filter: primaryFilter
    });
    this.generateWarrantyGridData = process(primaryFilteredData.data, {
      filter: {
        logic: "or",
        filters: [

          {
            field: "serviceOrderNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "jobNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "jobName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "orderDateUIString",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "scheduleDateUIString",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "poNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "shipFrom",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });

    if (!inputValue) {
      this.generateWarrantyGridstate.skip = 0;
      this.generateWarrantyGridstate.take = 10;
      this.loadGenerateWarrantyGridData();
    }
  }

}
